module.exports = __webpack_public_path__ + "img/1587633118.bb1be138.jpg";